export default {"src":"/_next/static/media/engaging-activities.66988002.svg","height":464,"width":226,"blurWidth":0,"blurHeight":0};